import isEmpty from 'lodash-es/isEmpty'

import { parseServerValidation } from '../../../../../utils/validation'
import { useDocFlowContext } from '../../../DocFlow.hooks'
import { DocFlowEditBuildingScopeModal } from '../../../DocFlowEditBuildingScopeModal'

import { getDocFlowProfileHeaderEditBuildingScopeInitialValues } from './useDocFlowProfileHeaderEditBuildingScope.utils'

export function useDocFlowProfileHeaderEditBuildingScope() {
  const { docFlow, handleCloseModal, handleUpdateDocFlow, setModal } =
    useDocFlowContext()

  async function handleEditBuildingScope({
    payload,
    setErrors,
    setSubmitting,
  }) {
    try {
      await handleUpdateDocFlow(payload)

      handleCloseModal()
    } catch ({ response }) {
      setSubmitting(false)

      if (!isEmpty(response?.data)) {
        setErrors(parseServerValidation(response?.data))
      }
    }
  }

  function handleOpenEditBuildingScopeModal() {
    setModal(
      <DocFlowEditBuildingScopeModal
        initialValues={getDocFlowProfileHeaderEditBuildingScopeInitialValues(
          docFlow
        )}
        onClose={handleCloseModal}
        onSubmit={handleEditBuildingScope}
      />
    )
  }

  return { handleOpenEditBuildingScopeModal }
}
